import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'app-popup-setting-frame',
  templateUrl: './popup-setting-frame.component.html',
  styleUrls: ['./popup-setting-frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupSettingFrameComponent implements OnInit {
  @Input() title: string;
  @Input() desc: string;
  @Input() showBack = false;
  @Input() hideFooter = false;
  @Input() hideclose = false;
  @Input() disabledBtn = false;
  @Input() error = false;
  @Input() removePadding = false;
  @Input() buttonTitle: string;
  @Input() defaultIcon: string;
  @Input() imageUrl: string;
  @Output() closeNotifier = new EventEmitter<boolean>();
  @Output() clickNotifier = new EventEmitter<boolean>();
  backButtonTitle: string;
  constructor() {}

  ngOnInit() {
    this.backButtonTitle = './assets/img/new-back-button.svg';
  }

  closePopup() {
    this.closeNotifier.emit();
  }

  onSave() {
    this.clickNotifier.emit();
    // this.closeNotifier.emit();
  }
  backHover() {
    this.backButtonTitle = './assets/img/new-back-button-hover.svg';
  }
  backNormal() {
    this.backButtonTitle = './assets/img/new-back-button.svg';
  }
}
